/**
 * 403 — access-denied.
 *
 * Reached when a route guard denies a role (Phase 1 the only producer is a
 * RequireAuth fallback for archived users; richer 403 producers land in
 * Phase 2).
 */
import * as React from 'react';
import { Link } from 'react-router-dom';

export function ForbiddenPage(): React.ReactElement {
  return (
    <section
      data-testid="forbidden"
      aria-labelledby="forbidden-title"
      className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 py-16 text-center"
    >
      <span aria-hidden className="text-5xl font-semibold text-muted">
        403
      </span>
      <h1 id="forbidden-title" className="text-xl font-semibold text-ink">
        Доступ запрещён
      </h1>
      <p className="text-sm text-muted-foreground">У вас нет прав для просмотра этой страницы.</p>
      <Link to="/" className="text-sm text-accent underline-offset-4 hover:underline">
        На главную
      </Link>
    </section>
  );
}
